module.exports = __webpack_public_path__ + "img/ok01.ef68f0da.png";